export default {
    title: 'สุ่มดาว',
    labels: {
        inventory: 'อวตารที่มี',
        machine: 'เครื่องสุ่มดาว',
    },
    messages: {
        insufficientStars: 'ดาวไม่พอ 😢',
        ctaText: 'กดที่ฉันเพื่อเก็บเข้าคลังเลย!',
    },
};
